import React from 'react';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';

// material-ui
import { Paper, Stack, Typography } from '@mui/material';

//components
import OcpfWatchSubscriptionTypeCount from '../dataObject/OcpfWatchSubscriptionTypeCount';

interface Props {
    typeCounts: OcpfWatchSubscriptionTypeCount[];
}

const SubscriptionTypeChart = (props: Props) => {

    const total = props.typeCounts.reduce((sum, t) => sum + t.subscriptionTypeCount, 0);

    return (
        <Stack component={Paper} variant="outlined" marginTop={1} padding={2}>
            <Typography variant="subtitle2" textAlign="center">Subscriptions by type</Typography>
            <PieChart
                series={[
                    {
                        data: props.typeCounts.map(t => ({
                            id: t.subscriptionTypeId,
                            value: t.subscriptionTypeCount,
                            label: `${t.subscriptionTypeDescription} (${t.subscriptionTypeCount})`
                        })),
                        arcLabel: item => `${Math.round(item.value / total * 100)}%`,
                        arcLabelMinAngle: 20,
                        innerRadius: 30,
                        paddingAngle: 1,
                        cornerRadius: 3,
                        highlightScope: { fade: 'global', highlight: 'item' }
                    }
                ]}
                sx={{ [`& .${pieArcLabelClasses.root}`]: { fill: 'white', fontSize: 12 } }}
                slotProps={{ legend: { direction: 'column', position: { vertical: 'middle', horizontal: 'right' } } }}
                margin={{ top: 10, right: 230, bottom: 10, left: 10 }}
                height={220}
            />
        </Stack>
    );
};

export default SubscriptionTypeChart;
